import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeCount',
  standalone: true,
})
export class RemoveCountPipe implements PipeTransform {
  transform(value: string): string {
    const regex = /\s*\(\d+\)\s*$/;

    return value.replace(regex, '');
  }
}
